import { env } from './env'
import { httpClient } from './httpClient'

/**
 * Recurso de armazenamento de arquivos (`idPublico`), compartilhado por
 * `arquivos` do colaborador e `contracheques` — ambos removidos pelo mesmo
 * endpoint. A remoção é reversível no back-end (desativação), mas o front
 * trata como definitiva: some das listagens e o link de download passa a
 * dar 404 imediatamente.
 */
export const armazenamentoApi = {
  remove: async (idPublico: string): Promise<void> => {
    await httpClient.delete(`/armazenamento/${idPublico}`)
  },
}

/** URL pública (rota anônima) para abrir/baixar um arquivo armazenado. */
export const armazenamentoUrl = (idPublico: string) =>
  `${env.apiBaseUrl}/armazenamento/${idPublico}`
